"use client";

import { useEffect, useRef } from "react";
import { trackPageView } from "../events";

/**
 * SPA 路由 PV 上报 hook · 接收完整 path-and-query 字符串。
 * 首次 mount 跳过(Metrica tag init 自带首屏 hit),之后每次 url 变化发一次 hit。
 *
 * 调用方:
 * - Next.js App Router: `usePathname() + '?' + searchParams.toString()`
 * - TanStack Router: `useRouterState({ select: s => s.location.pathname })`
 */
export function usePageView(url: string): void {
  const isFirst = useRef(true);
  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackPageView(url);
  }, [url]);
}
